import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class INDRAPackService {
  private packs = new BehaviorSubject<any[]>([]);
  currentPacks = this.packs.asObservable();

  private packSeat = new BehaviorSubject<any>({});
  packSeatSelection = this.packSeat.asObservable();

  constructor() { }

  addPack(value: any) {
    const currentValue = this.packs.getValue()
    const updatedValue = [...currentValue, value];
    this.packs.next(updatedValue);
  }

  changePack(value: any) {
    this.packs.next(value);
  }

  removePack(value: any) {
    const currentValue = this.packs.getValue();
    const updatedValue = currentValue.filter(pack => pack.passengers[0].codeList[0].code != value.passengers[0].codeList[0].code || pack.flightId != value.flightId);
    this.packs.next(updatedValue);
  }

  selectSeats(value: any) {
    this.packSeat.next(value);
  }
}